import { useContext } from 'react';
import { inject, MobXProviderContext } from 'mobx-react';
export const withStores = (...stores) => (component) => inject(...stores)(component);
export const withStore = withStores('store');
export const useStore = () => useContext(MobXProviderContext).store;
